export interface Tomo {
  numero: string;
  icon: string;
  titulo: string;
  subtitulo: string;
  descripcion: string;
  temario: string[];
  accent: {
    text: string;
    bg: string;
    chipBg: string;
    border: string;
  };
}

// Paleta secundaria de tomos: azul, violeta, rojo, esmeralda, turquesa, amarillo.
// El Tomo 07 utiliza el verde de marca para distinguir el nuevo contenido aprobado.
export const tomos: Tomo[] = [{
  numero: '01',
  icon: '📖',
  titulo: 'El Código del Fútbol Femenino',
  subtitulo: 'La guía definitiva para entender a la jugadora moderna',
  descripcion: 'Todo lo que necesitás saber para entrenar mujeres con criterio, ciencia y resultados reales.',
  temario: ['Diferencias fisiológicas mujer vs hombre en el deporte.', 'Ciclo menstrual y rendimiento deportivo.', 'Psicología de la jugadora femenina.', 'Cómo crear vínculos de confianza con el plantel.', 'Errores más comunes al trasladar metodología masculina al fútbol femenino.', 'El nuevo perfil del entrenador/a de fútbol femenino.', 'Cómo adaptar la carga según el estado hormonal del plantel.', 'Lesiones más frecuentes en la mujer futbolista y cómo prevenirlas.'],
  accent: {
    text: 'text-blue-600',
    bg: 'bg-blue-500',
    chipBg: 'bg-blue-50',
    border: 'border-blue-200'
  }
}, {
  numero: '02',
  icon: '📅',
  titulo: 'Planificación Anual Sin Errores',
  subtitulo: 'Sistema completo de periodización para equipos femeninos',
  descripcion: 'Dejá de arrancar cada semana desde cero. Toda la temporada estructurada y lista para ejecutar.',
  temario: ['Cómo armar un macrociclo, mesociclo y microciclo real.', 'Planificación según categorías: infantil, juvenil y adulta.', 'Cómo adaptar la carga según el ciclo menstrual del plantel.', 'Modelo de temporada completa lista para usar.', 'Gestión de cargas con plantel reducido.', 'Cómo planificar con poco tiempo de entrenamiento semanal.', 'Periodización táctica aplicada al fútbol femenino.', 'Control de cargas y recuperación activa.'],
  accent: {
    text: 'text-purple-600',
    bg: 'bg-purple-500',
    chipBg: 'bg-purple-50',
    border: 'border-purple-200'
  }
}, {
  numero: '03',
  icon: '💪',
  titulo: 'Preparación Física Específica',
  subtitulo: 'Entrenamiento funcional diseñado exclusivamente para la mujer futbolista',
  descripcion: 'El cuerpo de la mujer no es un hombre más pequeño. Entrenalo con la metodología correcta.',
  temario: ['Trabajo de fuerza adaptado a la mujer futbolista.', 'Prevención de lesiones específicas: rodilla, tobillo y cadera.', 'Velocidad, agilidad y coordinación específica para el fútbol femenino.', 'Resistencia aeróbica y anaeróbica dentro del campo.', '+40 ejercicios físicos con descripción completa.', 'Cómo integrar el trabajo físico con pelota dentro del campo.', 'Tests de evaluación física adaptados a la mujer.', 'Recuperación post-partido y microciclo semanal.'],
  accent: {
    text: 'text-red-600',
    bg: 'bg-red-500',
    chipBg: 'bg-red-50',
    border: 'border-red-200'
  }
}, {
  numero: '04',
  icon: '⚽',
  titulo: 'Táctica y Sistema de Juego',
  subtitulo: 'Cómo construir un equipo ganador desde cero',
  descripcion: 'Los sistemas más efectivos del fútbol femenino actual, explicados paso a paso para cualquier nivel de plantel.',
  temario: ['Los sistemas más efectivos para el fútbol femenino actual.', 'Cómo enseñar conceptos tácticos a jugadoras de todos los niveles.', 'Organización defensiva y ofensiva paso a paso.', 'Transiciones, pressing y salida limpia de balón.', 'Cómo adaptar la táctica al nivel real del plantel.', '+30 situaciones tácticas explicadas con diagramas.', 'Juego posicional aplicado al fútbol femenino.', 'Cómo corregir tácticamente durante el entrenamiento.'],
  accent: {
    text: 'text-emerald-600',
    bg: 'bg-emerald-500',
    chipBg: 'bg-emerald-50',
    border: 'border-emerald-200'
  }
}, {
  numero: '05',
  icon: '📋',
  titulo: 'Sesiones Listas para Usar',
  subtitulo: '+60 sesiones completas organizadas por objetivo',
  descripcion: 'Abrís el PDF, elegís la sesión del día y entrás al campo con todo pensado. Así de simple.',
  temario: ['Sesiones de pretemporada, competencia y descarga.', 'Sesiones técnico-tácticas por posición.', 'Sesiones de transición y juego reducido.', 'Sesiones para planteles con poco tiempo de entrenamiento semanal.', 'Formato listo para imprimir o usar en tablet.', 'Cómo modificar cada sesión según el nivel del grupo.', 'Sesiones para trabajar sin arquera o con plantel incompleto.', 'Sesiones de recuperación y descarga post-partido.'],
  accent: {
    text: 'text-teal-600',
    bg: 'bg-teal-500',
    chipBg: 'bg-teal-50',
    border: 'border-teal-200'
  }
}, {
  numero: '06',
  icon: '⭐',
  titulo: 'Liderazgo y Gestión de Equipo',
  subtitulo: 'El lado humano que ningún curso te enseña',
  descripcion: 'Saber de fútbol no alcanza. Este tomo te convierte en el entrenador/a que cada equipo necesita.',
  temario: ['Cómo liderar un grupo femenino con autoridad y empatía.', 'Gestión de conflictos dentro del plantel.', 'Comunicación efectiva en el vestuario y en el campo.', 'Cómo motivar jugadoras en momentos de crisis.', 'Charlas técnicas que generan impacto real.', 'Cómo construir identidad y cultura de equipo.', 'Manejo de egos, jerarquías y capitanas.', 'Comunicación con dirigentes, padres y familias.'],
  accent: {
    text: 'text-yellow-600',
    bg: 'bg-yellow-500',
    chipBg: 'bg-yellow-50',
    border: 'border-yellow-200'
  }
}, {
  numero: '07',
  icon: '🎯',
  titulo: 'Desarrollo Individual de la Jugadora',
  subtitulo: 'Cómo detectar lo que necesita mejorar cada jugadora y construir su progresión paso a paso.',
  descripcion: 'Evaluá, comprendé y desarrollá a cada jugadora según sus necesidades reales. Creá objetivos individuales, planes de mejora y seguimientos concretos para que cada futbolista evolucione y el equipo también.',
  temario: ['El desarrollo individual dentro del equipo.', 'Cómo crear el perfil de cada jugadora.', 'Evaluación técnica y toma de decisiones.', 'Evaluación física y prevención de sobrecargas.', 'Evaluación táctica y comprensión del juego.', 'Motivación, confianza y mentalidad competitiva.', 'Objetivos individuales y planificación de 90 días.', 'Progresiones por nivel.', 'Adaptaciones por posición.', 'Cómo trabajar distintos niveles en una misma sesión.', 'Seguimiento mensual y medición de avances.', 'Devoluciones, correcciones y conversaciones difíciles.', 'Integración del desarrollo individual con el plan del equipo.', 'Casos prácticos de jugadoras con distintos perfiles.'],
  accent: {
    text: 'text-brandgreen-hover',
    bg: 'bg-brandgreen',
    chipBg: 'bg-green-50',
    border: 'border-green-200'
  }
}];
